import Api from '@/services/Api'

export default {
    leaDepartamentos(){
        return Api().get('leaDepartamentos')
    },
    leaMunicipios(){
        return Api().get('leaMunicipios')
    },
}
